import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { split, map, capitalize, join } from "lodash";
import * as SolidIcons from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from 'react-i18next';

export default function Module(props) {
  const { icon, title, patient_count, percentage, bgColor, onClick, moduleId, flex = "0 0 calc(49.99% - 10px)" } =
    props;
    const { t } = useTranslation();
    const PATIENTS=t("PATIENTS")
  const hypenToCapCase = (val) => {
    const arr = split(val, "-");
    const updatedArr = map(arr, (str) => capitalize(str));
    return join(updatedArr, "");
  };
  return (
    <div
      className="!p-6 w-full cursor-pointer card"
      style={{
        flex,
        whiteSpace: "nowrap",
        boxSizing: "border-box",
      }}
      onClick={() => onClick(moduleId)}
    >
      <div className="flex justify-content-between">
        <div>
          <div className="flex gap-3">
            <div
              style={{ backgroundColor: `#${bgColor}`, borderRadius: '4px', width: '4px' }}
            />
            <span className="text-xl text-tremor-default text-tremor-content dark:text-dark-tremor-content">
              {title}
            </span>
          </div>
          <div className="flex gap-2 align-items-center">
          <p className="text-3xl text-tremor-content-strong dark:text-dark-tremor-content-strong font-semibold pl-3">
            {patient_count}
          </p>
          <p className="text-l text-tremor-default text-tremor-content dark:text-dark-tremor-content">
            {PATIENTS}
          </p>
          </div>
        </div>
        {!icon?.includes("/") ? (
          <FontAwesomeIcon
            icon={SolidIcons["fa" + hypenToCapCase(icon)]}
            style={{
              maxWidth: "20%",
              width: "100%",
              maxHeight: "20%",
              height: "100%",
              color: "var(--primary-color)",
            }}
          />
        ) : (
          <img
          src={icon}
          style={{
            maxWidth: "20%",
            width: "100%",
            maxHeight: "20%",
            height: "100%",
          }}
        />
        )}
      </div>
    </div>
    // <div
    //   className="card grid"
    //   style={{
    //     backgroundColor: `#${bgColor}`,
    //     height: 170,
    //     borderRadius: 30,
    //     padding: "1rem",
    //     cursor: "pointer",
    //   }}
    //   onClick={() => onClick(moduleId)}
    // >
    //   <div className="col flex flex-column">
    //     <h4
    //       style={{
    //         color: "white",
    //         marginBottom: 10,
    //       }}
    //     >
    //       {title}
    //     </h4>
    //     <label
    //       className="text-l"
    //       style={{
    //         color: "white",
    //       }}
    //     >
    //       {patient_count} patients
    //     </label>
    //     <div className="module-progress pt-2">
    //       {/* <CircleProgress percentage={Number(percentage)} bgColor={bgColor} /> */}
    //     </div>
    //   </div>
    //   <div className="col text-right" style={{}}>
    //     {!icon?.includes("/") ? (
    //       <FontAwesomeIcon
    //         icon={SolidIcons["fa" + hypenToCapCase(icon)]}
    //         style={{
    //           width: "100%",
    //           height: "75%",
    //           color: "var(--primary-color)",
    //         }}
    //       />
    //     ) : (
    //       <img
    //         src={icon}
    //         style={{
    //           width: "100%",
    //           height: "75%",
    //         }}
    //       />
    //     )}
    //   </div>
    // </div>
  );
}
